import { get } from 'lodash';
import {
  capitaliseFirstLetter,
  actionHandlerWithFeatureFlag,
} from '../../utils';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { GET_WAITLIST_PARAMETERS_GQL } from '../models/waitlistModel';
import { FEATURE_FLAGS } from '../../utils/constants';
import {
  GET_WAITLIST_PARAMETERS,
  GET_WAITLIST_PARAMETERS_SUCCESS,
  GET_WAITLIST_PARAMETERS_ERROR,
} from './actionTypes';
import { msFetchAllTags } from '../../services/CentreWaitlistService';
import DatadogHandler from '../../utils/datadog';

const getWaitlistParameters = () => ({
  type: GET_WAITLIST_PARAMETERS,
  value: {
    isLoading: true,
  },
});

const getWaitlistParametersSuccess = ({ data }) => ({
  type: GET_WAITLIST_PARAMETERS_SUCCESS,
  value: {
    isLoading: false,
    data,
  },
});

const getWaitlistParametersError = error => ({
  type: GET_WAITLIST_PARAMETERS_ERROR,
  value: {
    isLoading: false,
    data: null,
    error,
  },
});

export const monoFetchWaitlistParameters = async (dispatch, reqData) => {
  try {
    const result = await SkApolloRequest({
      type: 'query',
      params: {
        query: GET_WAITLIST_PARAMETERS_GQL,
        variables: reqData,
      },
    });
    return result;
  } catch (error) {
    DatadogHandler.addError(error);
    DatadogHandler.sendLog(error, {}, 'error');
    dispatch(getWaitlistParametersError({ error: error.message }));
    return error;
  }
};

export const fetchWaitlistParameters = reqData => async dispatch => {
  dispatch(getWaitlistParameters());
  try {
    const newReqData = {
      IDSchool: reqData.fkSchool,
      pagination: {
        ...reqData.pagination,
      },
    };
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msFetchAllTags,
        monoHandler: monoFetchWaitlistParameters,
        extraData: newReqData,
        dispatch,
      }
    );
    if (get(result, 'data.findAllTags.data')) {
      result.data.findAllTags.data = result.data.findAllTags.data.map(item => ({
        ...item,
        type: capitaliseFirstLetter(item.type),
      }));
    }
    dispatch(getWaitlistParametersSuccess({ data: result }));
    return result;
  } catch (error) {
    return error;
  }
};

export default fetchWaitlistParameters;
